import history from 'aurora-utils/history';
import * as types from '../constants/auroraUiConstants';
import store from '../configureStore';

export const toggleAction = () => dispatch => dispatch({ type: types.TOGGLE_SIDEBAR });

export const changeDirectionAction = direction => ({
  type: types.CHANGE_DIRECTION,
  direction,
});

export const playTransitionAction = isLoaded => dispatch => {
  dispatch({
    type: types.LOAD_PAGE,
    isLoaded,
  });
};

export const persistStore = locale => {
  const { origin } = window.location;
  const { location } = history;
  const { pathname, search } = location;
  let newBasename = '/en';
  if (locale === 'ar') newBasename = '/ar';
  const storeState = JSON.stringify(store.getState());
  localStorage.setItem('lang', locale);
  localStorage.setItem('store', storeState);
  localStorage.setItem('history', JSON.stringify(history.location));
  const params = {
    Site: {
      Language: locale.toUpperCase(),
    },
  };
  // window.clevertap.profile.push(params);
  setTimeout(() => {
    window.location.replace(origin + newBasename + pathname + search);
  }, 1000);
};
